/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Step_1_TitleInputs */

const da_forside_step_1_title = /** @type {(inputs: Forside_Step_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læg materialet ind`)
};

/** @type {(inputs: Forside_Step_1_TitleInputs) => LocalizedString} */
const en_forside_step_1_title = da_forside_step_1_title;

/**

* @param {Forside_Step_1_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_step_1_title = /** @type {((inputs?: Forside_Step_1_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Step_1_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_step_1_title(inputs)
	return /** @type {LocalizedString} */ ("Læg materialet ind")
});